module.exports = __webpack_public_path__ + "img/user-12.78921a8e.jpg";